module.exports = __webpack_public_path__ + "static/media/parceiro(3).0d65ef6a.png";